import React from 'react';
import { PromosPropType } from '@propTypes';
import styles from './styles/index.module.scss';
import MenuPromosItem from './MenuPromosItem';

const MenuPromosList = ({ promos }) => (
  <div className={styles.promos}>
    {promos.map(promo => (
      <MenuPromosItem key={promo.campaign_uuid} promo={promo} />
    ))}
  </div>
);

MenuPromosList.propTypes = {
  promos: PromosPropType.isRequired,
};

MenuPromosList.displayName = 'MenuPromosList';

export default MenuPromosList;
